export const CONFIRMED_CREATE_IMPLEADS_ACTION = "CONFIRMED_CREATE_IMPLEADS_ACTION";
export const CONFIRMED_DELETE_IMPLEADS_ACTION = "CONFIRMED_DELETE_IMPLEADS_ACTION";
export const CONFIRMED_EDIT_IMPLEADS_ACTION = "CONFIRMED_EDIT_IMPLEADS_ACTION";
export const CONFIRMED_GET_IMPLEADS = "CONFIRMED_GET_IMPLEADS";